import { stringify } from 'query-string';

import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { fetcher } from '@dashboard/services/request';

async function getStatistics(
  { metric, dateStart, dateEnd, unit, timezoneOffset },
  sellerId,
  token,
) {
  return fetcher(
    `/sellers/${sellerId}/statistics/${metric}?${stringify({
      dateStart,
      dateEnd,
      unit,
      timezoneOffset,
    })}`,
    token,
  );
}

export default function useStatisticsQueries() {
  const { token, sellerId } = useAuth();

  return {
    getStatistics: ({ metric, dateStart, dateEnd, unit, timezoneOffset }) =>
      getStatistics({ metric, dateStart, dateEnd, unit, timezoneOffset }, sellerId, token),
  };
}
